export const isCypressTest = () => Boolean(process.env.IS_CYPRESS_TEST);
